module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Media/Vynil-c2ae62cab9b7e56e6e6e912082f9cbdd002477421b3dd10b01003f16e28ea9be.svg";